// AUTO-ESTRATTO da Mercato.jsx (refactor strutturale Fase 10.02) — nessun cambio di logica/UI/testid.
export const KIND_LABELS = {
    transfer: "Trasferimento",
    loan: "Prestito secco",
    loan_obligation: "Prestito + Obbligo riscatto",
    loan_option: "Prestito + Diritto riscatto",
};

export const KIND_COLORS = {
    transfer: "#2BB6FF",
    loan: "#8F95A3",
    loan_obligation: "#FF7A1A",
    loan_option: "#E8FF00",
};

export function fmt(n) {
    if (!n) return "0";
    if (n >= 1_000_000) return `${(n / 1_000_000).toFixed(1)}mln`;
    if (n >= 1_000) return `${(n / 1_000).toFixed(0)}k`;
    return String(n);
}

export function fmtDate(iso) {
    if (!iso) return "—";
    try {
        return new Date(iso).toLocaleDateString("it-IT", { day: "2-digit", month: "short", year: "numeric" });
    } catch {
        return iso.slice(0, 10);
    }
}

export const POSITION_ORDER = ["GK", "RB", "CB", "LB", "DMF", "CMF", "LMF", "RMF", "AMF", "LWF", "RWF", "SS", "CF"];
